import { render, staticRenderFns } from "./SaisieTableDisplay.vue?vue&type=template&id=824cd9f0&"
import script from "./SaisieTableDisplay.vue?vue&type=script&lang=js&"
export * from "./SaisieTableDisplay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports